module.exports = __webpack_public_path__ + "img/damnnlogo3.3e6656f7.png";